import { useEffect, useState } from "react";

import { PlusSmallIcon } from "@heroicons/react/24/outline";

import DismantlingBayModal from "../../components/dismantlingBays/DismantlingBayModal";
import DismantlingBaysTable from "../../components/dismantlingBays/DismantlingBaysTable";
import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useDismantlingBays from "../../data/useDismantlingBays";
import { IDismantlingBay } from "../../models/DismantlingBay";

export default function DismantlingBayEditor() {
  const { setInfo } = usePageNameContext();
  const { dismantlingBays } = useDismantlingBays();
  const [editDismantlingBay, setEditDismantlingBay] = useState<IDismantlingBay | undefined>(undefined);
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Dismantling Bay Editor",
      desc: "View and manage dismantling bays and production lines",
    });
  }, [setInfo]);

  const handleSetDismantlingBay = (dismantlingBay: IDismantlingBay) => {
    setEditDismantlingBay(dismantlingBay);
    setCreateOpen(true);
  };

  const handleAddDismantlingBay = () => {
    setEditDismantlingBay(undefined);
    setCreateOpen(true);
  };

  return dismantlingBays.isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <DismantlingBayModal
        open={createOpen}
        setOpen={setCreateOpen}
        dismantlingBay={editDismantlingBay}
      />
      <div className="mt-4 flex justify-between">
        <button
          className="bg-primary-600 hover:bg-primary-700 inline-flex items-center rounded-md border border-transparent px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm"
          type="button"
          onClick={handleAddDismantlingBay}
        >
          <PlusSmallIcon className="h-5 w-5 mr-2" />
          Add New Dismantling Bay
        </button>
      </div>

      <DismantlingBaysTable
        dismantlingBays={dismantlingBays.data?.data ?? []}
        setDismantlingBay={handleSetDismantlingBay}
      />
    </>
  );
}
